import React, { useState, useEffect } from 'react';
import {  useSelector } from 'react-redux';
import { closeModal, toggleLoading } from '../../../state/ModalSlice/ModalSlice';
import { db, storage } from '../../../Config/firebase';
import { doc, GeoPoint, getDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { RootState, useAppDispatch, useAppSelector } from '../../../state/state';
import { Box, Button, TextField, Switch, FormControlLabel, IconButton, CircularProgress, MenuItem, Dialog, DialogContent, InputAdornment, Radio } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { OfferConstraint } from '../../Subscriptions/Pages/Offers/Offers';
import discountPana from "../../../assets/GifsAndPlaceholders/Discount-pana.png"
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { getGeoHash, getLatLong } from '../utilityFunctions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { selectBankAccounts, selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2';
interface EditOfferModalProps {
    offerId: string;
}
const GEO_LOC_API = import.meta.env.VITE_GEOLOCATION_API_KEY || process.env.VITE_GEOLOCATION_API_KEY

const EditOfferModal: React.FC<EditOfferModalProps> = () => {
    const dispatch = useAppDispatch();
    const {offerId} = useAppSelector((state)=>state.ArbitrarySlice.ForEditOfferModal)
    const isOpen = useSelector((state: any) => state.ModalSlice.EditOfferModalOpen);
    const providerId: string = useAppSelector(selectEffectiveUID) 
    const [location, setLocation] = useState<any>(null);
    const [formData, setFormData] = useState({
        BuzzName: '',
        Description: '',
        OfferCode: '',
        isLive: false,
        url: '',
        offerConstraint: OfferConstraint.EVERYDAY,
        StartDate: '',
        EndDate: '',
        Price : "",
        geoLocation: {
            hash: "", latlang: new GeoPoint(0,0)
        },
        placeName: "",
        placeAddress: "",
        paymentProfileId: 0,
        TermsAndConditions: ""
    });

    const [imageFile, setImageFile] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [imageSizeExceeded, setImageSizeExceeded] = useState<boolean>(false);

    // Error states
    const [errors, setErrors] = useState({
        BuzzName: false,
        Description: false,
        OfferCode: false,
        StartDate: false,
        EndDate: false,
        Price : false
    });

    const [paymentProfileID, setPaymentProfileID] = useState<number>(0);
    const [offerType, setOfferType] = useState<'free' | 'paid'>('free');

    useEffect(() => {
        const fetchOffer = async () => {
            if (offerId && isOpen) {
                try {
                    const offerDoc = await getDoc(doc(db, 'ServiceProviders', providerId, 'Offers', offerId));
                    if (offerDoc.exists()) {
                        const offerData = offerDoc.data();
                        setOfferType(offerData.Price > 0 ? 'paid' : 'free');
                        setFormData({
                            BuzzName: offerData.BuzzName || '',
                            Description: offerData.Description || '',
                            OfferCode: offerData.OfferCode || '',
                            isLive: offerData.isLive || false,
                            url: offerData.url || '',
                            offerConstraint: offerData.offerConstraint || OfferConstraint.EVERYDAY,
                            StartDate: offerData.StartDate ? offerData.StartDate.toDate().toISOString().split('T')[0] : '',
                            EndDate: offerData.EndDate ? offerData.EndDate.toDate().toISOString().split('T')[0] : '',
                            Price : (offerData.Price)?.toString(),
                            geoLocation: offerData.geoLocation,
                            placeName: offerData.placeName,
                            placeAddress: offerData.placeAddress,
                            paymentProfileId: offerData.paymentProfileId,
                            TermsAndConditions: offerData.TermsAndConditions
                        });
                        if (offerData.url) {
                            setImagePreview(offerData.url);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching offer:", error);
                }
            }
        };

        fetchOffer();
    }, [offerId,isOpen]);


    useEffect(() => {
        if (location) {
            getLatLong(location.value.place_id).then((geometry: { lat: any, lng: any }) => {
                const geoPoint = new GeoPoint(geometry.lat, geometry.lng);
                
                setFormData(prev => ({ ...prev, geoLocation: { hash: geoPoint != null ? getGeoHash(geoPoint) || "" : "", latlang: geoPoint }, 
                placeName: location.value.structured_formatting.main_text,
                placeAddress: location.label }));
         });        
        }
    }, [location]);



    // Modal functions
    const handleClose = () => {
        dispatch(closeModal('EditOfferModalOpen'));
        ResetStates()
    };

    function ResetStates() {
        setFormData({
            BuzzName: '',
            Description: '',
            OfferCode: '',
            isLive: false,
            url: '',
            offerConstraint: OfferConstraint.EVERYDAY,
            StartDate: '',
            EndDate: '',
            Price:'',
            geoLocation: {
                hash: "", latlang: new GeoPoint(0,0),
            },
            placeName: "",
            placeAddress: "",
            paymentProfileId: 0,
            TermsAndConditions: ""
        });
        setErrors({
            BuzzName: false,
            Description: false,
            OfferCode: false,
            StartDate: false,
            EndDate: false,
            Price: false
        });
    }

    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading)
    // Handle change functions
    const handleChangeBuzzName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, BuzzName: event.target.value }));
        setErrors(prev => ({ ...prev, BuzzName: false }));
    };


    const handleChangeDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, Description: event.target.value }));
        setErrors(prev => ({ ...prev, Description: false }));
    };

    const handleChangeOfferCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, OfferCode: event.target.value }));
        setErrors(prev => ({ ...prev, OfferCode: false }));
    };

    const handleChangeIsLive = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, isLive: event.target.checked }));
    };

    const handleChangeOfferConstraint = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, offerConstraint: event.target.value as OfferConstraint }));
    };

    const handleChangeStartDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, StartDate: event.target.value }));
        setErrors(prev => ({ ...prev, StartDate: false }));
    };

    const handleChangeEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, EndDate: event.target.value }));
        setErrors(prev => ({ ...prev, EndDate: false }));
    };

    const handleChangeTermsAndConditions = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, TermsAndConditions: event.target.value }));
    };

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setImageSizeExceeded(false);
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setImageSizeExceeded(true);
                return;
            }
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    // Validation function

    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };

        if (formData.BuzzName.trim() === '') {
            newErrors.BuzzName = true;
            isValid = false;
        }
        if (formData.Description.trim() === '') {
            newErrors.Description = true;
            isValid = false;
        }
        if (formData.OfferCode.trim() === '') {
            newErrors.OfferCode = true;
            isValid = false;
        }
        if (formData.StartDate === '') {
            newErrors.StartDate = true;
            isValid = false;
        }
        if (formData.EndDate === '') {
            newErrors.EndDate = true;
            isValid = false;
        }if (formData.Price.trim() === "") {
            newErrors.Price=true
            isValid = false
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleChangePrice = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        // Function to handle only decimal and number inputs
        if (!value) {
            setFormData(prev => ({ ...prev, Price:"" }));
            return;
        }
        let decimalCount = 0;
        for (let i = 0; i < value.length; i++) {
            const char = value[i];
            if (char >= '0' && char <= '9') { /* empty */
            } else if (char === '.') {
                if (decimalCount === 0) {
                    decimalCount++;
                } else {
                    return;
                }
            } else {
                return;
            }
        }
        setFormData(prev => ({ ...prev, Price: event.target.value }));
        setErrors(prev => ({ ...prev, Price: false }));
    };

    // Submit function
    const handleImageUpload = async (): Promise<string> => {
        if (imageFile) {
            const storageRef = ref(storage, `offers/${providerId}/${imageFile.name}`);
            await uploadBytes(storageRef, imageFile);
            return getDownloadURL(storageRef);
        } else if (imagePreview) {
            return imagePreview;
        } else {
            // Upload default image if no image is selected or previously existed
            const defaultImageBlob = await fetch(discountPana).then(r => r.blob());
            const storageRef = ref(storage, `offers/${providerId}/default_discount_pana.png`);
            await uploadBytes(storageRef, defaultImageBlob);
            return getDownloadURL(storageRef);
        }
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateForm()) return;

        dispatch(toggleLoading(true));
        try {
            const imageUrl = await handleImageUpload();
            const offerRef = doc(db, 'ServiceProviders', providerId, 'Offers', offerId);
            await updateDoc(offerRef, {
                ...formData,
                url: imageUrl,
                StartDate: new Date(formData.StartDate),
                EndDate: new Date(formData.EndDate),
                Price : Number(formData.Price),
                geoLocation: {
                    hash: formData.geoLocation.hash, latlang: formData.geoLocation.latlang,  placeName: formData.placeName,
                    address: formData.placeAddress
                },
                placeName: formData.placeName,
                placeAddress: formData.placeAddress,
                accountId: BankAccounts ? BankAccounts[paymentProfileID].razorpayAccountId : null

            });
            handleClose();
        } catch (error) {
            console.error("Error updating offer:", error);
            // Optionally, show an error message to the user
        } finally {
            dispatch(toggleLoading(false));
        }
    };
    const BankAccounts = useAppSelector(selectBankAccounts);
    const bankAccountOptions = BankAccounts ? BankAccounts.map(bankAccount => {
        return (
            bankAccount.iFSC.slice(0, 4) + " - " + bankAccount.accountNo)
    }) : [];

    const handleChangePaymentProfile = (event: React.ChangeEvent<HTMLInputElement>) => {
       
        setFormData(prev => ({ ...prev, paymentProfileId: Number(event.target.value) }));   
        setPaymentProfileID(Number(event.target.value));
    };

    const handleOfferTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as 'free' | 'paid';
        setOfferType(value);
        if (value === 'free') {
            setFormData(prev => ({ ...prev, Price: "0" }));
        }
    };

    // ... (rest of the component code)

    return (
        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                    width: { xs: 'calc(100% - 32px)', sm: 'auto' },
                    maxWidth: { xs: 'calc(100% - 32px)', sm: '600px', md: '800px' },
                    minWidth: { sm: '600px', md: '800px' },
                    margin: { xs: '16px', sm: 'auto' },
                    maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' },
                    overflow: 'hidden',
                    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important'
                },
            }}
            maxWidth="md"
            fullWidth
            open={isOpen}
            onClose={handleClose}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ 
                paddingX: { xs: "16px", sm: "24px", md: "60px" }, 
                paddingY: { xs: "30px", sm: "40px", md: "50px" },
                maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' },
                minHeight: { sm: '70vh' },
                overflowY: 'auto'
            }} className={"bg-white"}>
                <div className={"w-full max-w-full"}>
                    <div className={"header pb-3 sm:pb-[20px]"}>
                        <p className={"text-lg sm:text-cf_heading font-[600] "}>Edit Offer</p>

                    </div>

                    <div className={"absolute right-2 sm:right-4 top-2 sm:top-4"}><IconButton onClick={handleClose} size="small" sx={{ padding: { xs: '4px', sm: '8px' } }}>
                        <CloseIcon sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }} />
                    </IconButton></div>

                    <div className={"pt-0"}>
                        <div className={""}>
                            <div className={""}>
                                <Box
                                    component={"div"}
                                    sx={{}}
                                >
                                    <div className="flex flex-col gap-4">
                                        <TextField
                                            label="Buzz Name*"
                                            value={formData.BuzzName}
                                            onChange={handleChangeBuzzName}
                                            error={errors.BuzzName}
                                            helperText={errors.BuzzName ? "Buzz Name is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },

                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                        />
                                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4">
                                            <p className="text-xs sm:text-sm text-gray-600 font-medium">Offer Type:</p>
                                            <div className="flex gap-3 sm:gap-4">
                                                <FormControlLabel
                                                    value="free"
                                                    control={
                                                        <Radio
                                                            checked={offerType === 'free'}
                                                            onChange={handleOfferTypeChange}
                                                            value="free"
                                                            size="small"
                                                            sx={{ padding: { xs: '4px', sm: '9px' } }}
                                                        />
                                                    }
                                                    label={<span style={{ fontSize: '14px' }}>Free</span>}
                                                />
                                                <FormControlLabel
                                                    value="paid"
                                                    control={
                                                        <Radio
                                                            checked={offerType === 'paid'}
                                                            onChange={handleOfferTypeChange}
                                                            value="paid"
                                                            size="small"
                                                            sx={{ padding: { xs: '4px', sm: '9px' } }}
                                                        />
                                                    }
                                                    label={<span style={{ fontSize: '14px' }}>Paid</span>}
                                                />
                                            </div>
                                        </div>
                                        {offerType === 'paid' && (
                                            <TextField
                                                label="Price"
                                                value={formData.Price}
                                                onChange={handleChangePrice}
                                                error={errors.Price}
                                                helperText={errors.Price ? "Price is required" : ""}
                                                fullWidth
                                                size='small'
                                                InputProps={{
                                                    startAdornment: <InputAdornment sx={{ fontSize: '14px' }}
                                                        position="start">₹</InputAdornment>,
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue',
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '14px',
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    width: { xs: '100%', sm: '550px' },
                                                }}
                                            />
                                        )}
                                        <TextField
                                            label="Description*"
                                            value={formData.Description}
                                            onChange={handleChangeDescription}
                                            error={errors.Description}
                                            helperText={errors.Description ? "Description is required" : ""}
                                            fullWidth
                                            multiline={true}

                                            rows={2}
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: { xs: '14px', sm: '14px' },
                                                    },
                                                },

                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                        /> <TextField
                                        label="Offer Code*"
                                        value={formData.OfferCode}
                                        onChange={handleChangeOfferCode}
                                        error={errors.OfferCode}
                                        helperText={errors.OfferCode ? "Offer Code is required" : ""}
                                        fullWidth
                                        size='small'
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: 'grey',
                                                    borderRadius: '10px',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'grey',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'skyblue',
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: { xs: '14px', sm: '14px' },
                                                },
                                            },

                                            fontWeight: 400,
                                            width: { xs: '100%', sm: '550px' },
                                        }}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={formData.isLive}
                                                    onChange={handleChangeIsLive}
                                                />
                                            }
                                            label="Is Live"
                                        />
                                        <TextField
                                            select
                                            label="Offer Constraint"
                                            value={formData.offerConstraint}
                                            onChange={handleChangeOfferConstraint}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },

                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                        >
                                            {Object.values(OfferConstraint).map((constraint) => (
                                                <MenuItem key={constraint} value={constraint}>
                                                    {constraint}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField
                                            label="Start Date"
                                            type="date"
                                            value={formData.StartDate}
                                            onChange={handleChangeStartDate}
                                            error={errors.StartDate}
                                            helperText={errors.StartDate ? "Start Date is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },

                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            label="End Date"
                                            type="date"
                                            value={formData.EndDate}
                                            onChange={handleChangeEndDate}
                                            error={errors.EndDate}
                                            helperText={errors.EndDate ? "End Date is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: { xs: '14px', sm: '14px' },
                                                    },
                                                },

                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                        <div><Button
                                            variant="outlined"
                                            component="label"
                                            fullWidth
                                            sx={{
                                                mb: 0,
                                                borderRadius: '8px',
                                                textTransform: 'none',
                                                color: '#1D4ED8',
                                                borderColor: '#1D4ED8',
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                py: { xs: 0.75, sm: 1 },
                                                '&:hover': {
                                                    backgroundColor: '#1D4ED8', color: "#FFFFFF"
                                                },
                                            }}
                                        >
                                            <span className={"mr-1 flex justify-center items-center"}><AttachmentIcon sx={{ fontSize: { xs: '16px', sm: '18px' } }} /> </span> <span className="hidden sm:inline">Click here to upload Offers Display Image</span><span className="sm:hidden">Upload Image</span>
                                            <input
                                                type="file"
                                                accept="image/jpeg, image/png"
                                                hidden
                                                onChange={handleImageChange}
                                            />
                                        </Button></div>
                                        {imageSizeExceeded && (
                                            <p className="text-xs sm:text-sm" style={{ color: 'red' }}>Image size should not exceed 5MB</p>
                                        )}
                                        {imagePreview && (<Box sx={{ mb: 2, position: 'relative', width: { xs: 80, sm: 100 }, height: { xs: 80, sm: 100 } }}>
                                            <img src={imagePreview} alt="Logo preview"
                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                                            <IconButton
                                                onClick={() => {
                                                    setImageFile(null);
                                                    setImagePreview(null);
                                                }}
                                                sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'background.paper', padding: { xs: '4px', sm: '8px' } }}
                                            >
                                                <CloseIcon sx={{ fontSize: { xs: '16px', sm: '18px' } }} />
                                            </IconButton>
                                        </Box>)}
                                        <div className="flex flex-col gap-1">
                                            <p className="text-xs sm:text-sm text-gray-600 font-medium">Location</p>
                                            <GooglePlacesAutocomplete
                                                apiKey={GEO_LOC_API || process.env.GEO_LOC_API}
                                                selectProps={{
                                                    placeholder: "Search location",
                                                    value: location,
                                                    onChange: setLocation,
                                                    components: {
                                                        DropdownIndicator: () => (
                                                            <div className="px-2">
                                                                <LocationOnIcon fontSize="small" style={{ color: '#6B7280' }} />
                                                            </div>
                                                        )
                                                    },
                                                    styles: {
                                                        input: (provided) => ({
                                                            ...provided, backgroundColor: 'transparent', // Fully opaque white background
                                                        }), option: (provided) => ({
                                                            ...provided, backgroundColor: 'transparent', // Fully opaque white background
                                                        }), singleValue: (provided) => ({
                                                            ...provided, backgroundColor: 'transparent', // Fully opaque white background
                                                        }), control: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'transparent', // Fully opaque white background
                                                            borderColor: "gray",
                                                            boxShadow: 'none', // Remove the default shadow
                                                            '&:hover': {
                                                                borderColor: 'black', // Keep the border black on hover
                                                            },
                                                            '&:focus': {
                                                                borderColor: 'black', // Ensure the border is black when active
                                                            },
                                                            '&:active': {
                                                                borderColor: "black"
                                                            },
                                                            borderRadius: '10px',
                                                            fontSize: '14px'
                                                        }), menu: (provided) => ({
                                                            ...provided, backgroundColor: 'rgba(255, 255, 255, 1)', // Fully opaque white background
                                                            zIndex: 100, // Set z-index to 100
                                                        }), menuPortal: (provided) => ({
                                                            ...provided, zIndex: 100, // Ensure the menu portal has a z-index of 100
                                                        }),
                                                    },
                                                }}
                                            />
                                          {formData.placeName && <p className="text-xs sm:text-sm text-gray-500 mt-1 break-words">Selected Location: {formData.placeName} ,{formData.placeAddress}</p>}
                                        </div>
                                        
                                        <TextField
                                            size={"small"}
                                            id="Bank Account"
                                            select
                                            label="Bank account"
                                            value={paymentProfileID}
                                            onChange={handleChangePaymentProfile}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: { xs: '14px', sm: '14px' },
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                        >
                                            {/* Assuming you have a way to get bank account options */}
                                            {bankAccountOptions.length > 0 ? bankAccountOptions.map((option, index) => (
                                                <MenuItem key={index} value={index} sx={{ fontSize: { xs: '14px', sm: '14px' } }}>
                                                    {option}
                                                </MenuItem>
                                            )) : <MenuItem key="0" value={0} sx={{ fontSize: { xs: '14px', sm: '14px' } }}>No account Found</MenuItem>}
                                        </TextField>

                                        <TextField
                                            label="Terms and Conditions(Optional)"
                                            value={formData.TermsAndConditions}
                                            onChange={handleChangeTermsAndConditions}
                                            fullWidth
                                            multiline
                                            rows={2}
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: { xs: '14px', sm: '14px' },
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: { xs: '100%', sm: '550px' },
                                            }}
                                        />

                                        <div className={"flex flex-col sm:flex-row gap-2 pt-3 sm:pt-4"}>
                                            <button disabled={isLoading} onClick={(e) => {
                                                e.preventDefault();
                                                handleClose()
                                            }}
                                                className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg text-xs sm:text-sm ${(isLoading) ? "cursor-not-allowed" : "cursor-pointer"}`}>Cancel
                                            </button>


                                            <button
                                                onClick={handleSubmit}
                                                disabled={isLoading}
                                                className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center text-xs sm:text-sm ${(isLoading) ? "cursor-not-allowed" : "cursor-pointer"} `}>
                                                {isLoading && <CircularProgress sx={{ color: "white", width: '16px !important', height: '16px !important' }} />}
                                                <p className={"ml-2"}>{isLoading ? "Loading" : "Confirm"}</p>
                                            </button>

                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default EditOfferModal;